import React, { useEffect, useMemo } from 'react'
import Close from '@mui/icons-material/Close'
import InsertDriveFile from '@mui/icons-material/InsertDriveFile'

import { effectiveFileMime, isChatImageFile } from 'utils/chatAttachmentLimits'

import * as S from './styles'

interface Props {
  files: File[]
  onRemove: (index: number) => void
  disabled?: boolean
}

function truncateName(name: string, max = 18): string {
  const n = name.trim() || 'Arquivo'
  if (n.length <= max) return n
  return `${n.slice(0, max - 1)}…`
}

const ChatPendingAttachments: React.FC<Props> = ({
  files,
  onRemove,
  disabled,
}) => {
  const previewUrls = useMemo(
    () =>
      files.map((file) =>
        isChatImageFile(file) ? URL.createObjectURL(file) : null
      ),
    [files]
  )

  useEffect(() => {
    return () => {
      for (const url of previewUrls) {
        if (url) URL.revokeObjectURL(url)
      }
    }
  }, [previewUrls])

  if (files.length === 0) {
    return null
  }

  return (
    <S.PendingAttachmentsRow>
      {files.map((file, index) => {
        const previewUrl = previewUrls[index]
        const mime = effectiveFileMime(file)
        const isImage = isChatImageFile(file)

        return (
          <S.PendingAttachmentChip key={`${file.name}-${file.size}-${index}`}>
            {isImage && previewUrl ? (
              <S.PendingAttachmentThumb
                src={previewUrl}
                alt={file.name || 'Imagem'}
              />
            ) : (
              <S.PendingAttachmentIcon aria-hidden>
                <InsertDriveFile style={{ fontSize: 22 }} />
              </S.PendingAttachmentIcon>
            )}
            <S.PendingAttachmentMeta>
              <S.PendingAttachmentName title={file.name}>
                {truncateName(file.name)}
              </S.PendingAttachmentName>
              {mime ? (
                <S.PendingAttachmentMime>{mime.split('/')[1]}</S.PendingAttachmentMime>
              ) : null}
            </S.PendingAttachmentMeta>
            <S.PendingAttachmentRemove
              type="button"
              aria-label={`Remover ${file.name || 'anexo'}`}
              title="Remover anexo"
              disabled={disabled}
              onClick={() => onRemove(index)}
            >
              <Close style={{ fontSize: 14 }} />
            </S.PendingAttachmentRemove>
          </S.PendingAttachmentChip>
        )
      })}
    </S.PendingAttachmentsRow>
  )
}

export default ChatPendingAttachments
